var _path, _path2, _g, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgDatabaseUploadCheck = function SvgDatabaseUploadCheck(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 30 30",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "database_upload_check_svg__a",
    width: 30,
    height: 30,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0h30v30H0z"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#database_upload_check_svg__a)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "database_upload_check_svg__b",
    width: 13,
    height: 13,
    x: 16,
    y: 16,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.25 16.25h12.5v12.5h-12.5z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#database_upload_check_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m21.625 23.628-1.392-1.38a.51.51 0 0 0-.383-.16.56.56 0 0 0-.396.179.54.54 0 0 0-.175.39.54.54 0 0 0 .175.389l1.38 1.367q.34.34.791.34.452 0 .79-.34l3.13-3.149a.55.55 0 0 0 .17-.383.52.52 0 0 0-.17-.395.54.54 0 0 0-.389-.176.54.54 0 0 0-.39.176zm.877 4.81q-2.463 0-4.201-1.737-1.739-1.735-1.738-4.2 0-2.462 1.736-4.2 1.735-1.739 4.2-1.738 2.462 0 4.2 1.736 1.739 1.735 1.738 4.2 0 2.462-1.736 4.2-1.735 1.739-4.2 1.738"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15 11.197q2.733 0 5.504-.792t3.21-1.648q-.428-.918-3.177-1.713A19.9 19.9 0 0 0 15 6.25a20.2 20.2 0 0 0-5.518.773q-2.734.773-3.22 1.686.474.88 3.196 1.684t5.542.804m-.844 12.534q.082.519.227.982t.343.912q-2.221-.02-4.106-.372t-3.275-.951-2.18-1.413-.79-1.76V8.75q0-1.81 3.11-3.093Q10.598 4.377 15 4.376q4.404 0 7.514 1.282t3.111 3.093v5.808a7 7 0 0 0-.912-.33 8 8 0 0 0-.963-.216v-2.887q-1.577.918-3.857 1.41-2.28.495-4.893.482-2.68 0-4.948-.493-2.268-.492-3.802-1.399v4.07q1.534 1.253 3.946 1.754 2.412.503 4.804.503h.548a6.5 6.5 0 0 0-.54.893 9 9 0 0 0-.414.982 27.7 27.7 0 0 1-4.52-.5q-2.23-.435-3.824-1.392v3.815q.279.466 1.01.906.73.44 1.78.762 1.05.323 2.363.539t2.753.274"
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgDatabaseUploadCheck);
export default ForwardRef;